<label class="label-font">{{label}}</label>
<br>
<textarea class="custom-textarea" 
[maxlength]="maxlength"
[placeholder]="placeholder" 
oninput="this.value=this.value.slice(0,this.maxlength)" 
[style.width]="width" pInputTextarea [ngModel]="value" 
[ngClass]="{ 'error-border': invalidInput }"
[pTooltip]="invalidInputToolTip ? 'Please fill this field' : ''"
(input)="onValueInputChange($event)"  
(change)="onValueChange($event)"
[disabled]="isDisabled"></textarea>